import type { PageData } from 'src/types/types';

const setPageTrackingData = (data: PageData) => {
  if (typeof window !== 'undefined') {
    window.currentPageTrackingData = data;
  }
};

export default setPageTrackingData;
